import { Controller } from "@hotwired/stimulus"

// Страница размера: модалка удаления (overlay/Esc) + SVG-дропзона перезалива контура.
export default class extends Controller {
  static targets = ["deleteModal", "fileInput", "fileName", "clearFile"]

  openDelete() { this._open(this.deleteModalTarget) }
  close() { if (this.hasDeleteModalTarget) this._hide(this.deleteModalTarget) }
  backdrop(e) { if (e.target === e.currentTarget) this._hide(e.currentTarget) }
  _open(m) { m.classList.remove("hidden"); m.classList.add("flex"); this._esc = (e) => { if (e.key === "Escape") this.close() }; document.addEventListener("keydown", this._esc) }
  _hide(m) { m.classList.add("hidden"); m.classList.remove("flex"); if (this._esc) document.removeEventListener("keydown", this._esc) }

  chooseFile() { this.fileInputTarget.click() }
  dropFile(e) { e.preventDefault(); const f = e.dataTransfer?.files?.[0]; if (f) { this.fileInputTarget.files = e.dataTransfer.files; this.showFile(f.name) } }
  onFile() { const f = this.fileInputTarget.files?.[0]; if (f) this.showFile(f.name) }
  showFile(name) { if (this.hasFileNameTarget) this.fileNameTarget.textContent = name; if (this.hasClearFileTarget) this.clearFileTarget.classList.remove("hidden") }
  clearFile(e) { e.preventDefault(); e.stopPropagation(); if (this.hasFileInputTarget) this.fileInputTarget.value = ""; if (this.hasFileNameTarget) this.fileNameTarget.textContent = ""; if (this.hasClearFileTarget) this.clearFileTarget.classList.add("hidden") }
  allowDrop(e) { e.preventDefault() }
}
